(function() {
	'use strict';

	angular.module('gatewayApp').controller('HomeBranchViewController',
        HomeBranchViewController);

            HomeBranchViewController.$inject = [ '$scope', '$state', '$rootScope',
			'workflowSharedService', '$uibModalInstance', 'ManageHomeBranch', 'entity',
			'Workflow', 'GlobalValues','StaticLookUp','BankRegistration'];

	function HomeBranchViewController($scope, $state, $rootScope,
			workflowSharedService, $uibModalInstance, ManageHomeBranch, entity, Workflow,
			GlobalValues,StaticLookUp,BankRegistration) {
		var vm = this;
		vm.clear = clear;
		vm.approveHomeBranch = approveHomeBranch;
		vm.rejectHomeBranch = rejectHomeBranch;
		vm.discardHomeBranch = discardHomeBranch;
		$scope.showButton = false;
		$scope.showDiscardButton = false;
		vm.clicked = false;
		vm.ExpandOrCollapseUser1 = false;
		vm.ExpandOrCollapseUser2 = false;
		vm.ExpandOrCollapseBankDetails = true;
		vm.globalValues = GlobalValues;
		vm.homeBranchDetailsDTO = {};
		vm.isDefaultUsersRequired1 = false;
		vm.isDefaultUsersRequired2 = false;
        vm.bankValue=null;
        vm.bank=null;
        vm.homeBranchCountyValue=null;
        vm.state=null;

		if (workflowSharedService.viewFrom == 'homeBranch') {
			vm.homeBranch = entity;
            if(vm.homeBranch.bankName !=null && vm.homeBranch.bankName !=undefined){
                vm.homeBranch.bank = vm.globalValues.getBank();
                setBankValue();
                setStateValue();
				preparDeliveryModeDTOList(vm.homeBranch);

            }
			vm.homeBranch.currencyNotes = convertBooleanToYesNo(vm.homeBranch.currencyNotes)
			vm.homeBranch.forexCardLoad = convertBooleanToYesNo(vm.homeBranch.forexCardLoad)
			vm.homeBranch.remittance = convertBooleanToYesNo(vm.homeBranch.remittance)

			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'homebranchtodolist_checker') {
			vm.homeBranchDetailsDTO = angular.fromJson($rootScope.payload);

			if (vm.homeBranch  == undefined) {
				vm.homeBranch = vm.homeBranchDetailsDTO

				vm.homeBranch.currencyNotes = convertBooleanToYesNo(vm.homeBranch.currencyNotes)
			vm.homeBranch.forexCardLoad = convertBooleanToYesNo(vm.homeBranch.forexCardLoad)
			vm.homeBranch.remittance = convertBooleanToYesNo(vm.homeBranch.remittance)
			}
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			$scope.showButton = true;
			$scope.showDiscardButton = false;
		} else if (workflowSharedService.viewFrom == 'homebranchtodolist_maker') {
			vm.homeBranchDetailsDTO = angular.fromJson($rootScope.payload);
			if (vm.homeBranch == undefined || vm.homeBranch == null) {
				vm.homeBranch = vm.homeBranchDetailsDTO
				vm.homeBranch.currencyNotes = convertBooleanToYesNo(vm.homeBranch.currencyNotes)
			vm.homeBranch.forexCardLoad = convertBooleanToYesNo(vm.homeBranch.forexCardLoad)
			vm.homeBranch.remittance = convertBooleanToYesNo(vm.homeBranch.remittance)
			}
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			$scope.showButton = false;
			$scope.showDiscardButton = true;
		} else if (workflowSharedService.viewFrom == 'homebranch_auditLog') {
			vm.homeBranchDetailsDTO = angular.fromJson($rootScope.payload);
		

			if (vm.homeBranch == undefined) {
				vm.homeBranch=vm.homeBranchDetailsDTO
			}
			setBankValue();
			setStateValue();
			preparDeliveryModeDTOList(vm.homeBranch);
			$scope.showButton = false;
		}

		function convertBooleanToYesNo(value) {
			if(value || value == false) return value;
			return value == 'yes' ? true : ( value == 'no' ? false : null);
		}
		

        function setBankValue(){
        		if(vm.homeBranch.bankName !=null){

                    BankRegistration.getBankForShortName({bankName: vm.homeBranch.bankName},function(result){
                        vm.bank=result;
                    });
    		}
        }

        
        function setStateValue(){
           
        		if(vm.homeBranch.state!= null){
                    StaticLookUp.getStateobject({stateName:vm.homeBranch.state},function(result){
                        vm.stateName=result;
        })
    }
}

		function approveHomeBranch() {
			ManageHomeBranch.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			$uibModalInstance.dismiss('cancel');
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectHomeBranch() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardHomeBranch() {
			ManageHomeBranch.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			$uibModalInstance.dismiss('cancel');
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
		}
		function onDiscardError(error) {

		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function preparDeliveryModeDTOList(homeBranch) {
			getCurrencyPairList(homeBranch.bankName);
			prepardeliveryModeIsEnable(homeBranch);
			vm.forexCardLoad = homeBranch.forexCardLoad ? homeBranch.forexCardLoad.split(",") : [];
			vm.currencyNotes = homeBranch.currencyNotes ? homeBranch.currencyNotes.split(",") : [];
			vm.remittance = homeBranch.remittance ? homeBranch.remittance.split(",") : [];
			vm.forexCardIssuance = homeBranch.forexCardIssuance ? homeBranch.forexCardIssuance.split(",") : [];
		}

		function preparDeliveryModeList(currencyPairList, deliveryMode) {

			var deliveryModeMap = {};

			angular.forEach(deliveryMode, function (code) {
				deliveryModeMap[code] = true;
			});

			return currencyPairList.map(function (item) {
				return {
					CurrencyCode: item.baseCurrency.code,
					isEnable: !!deliveryModeMap[item.baseCurrency.code]
				};
			});
		}


		function getCurrencyPairList(bankName) {

			StaticLookUp.getCurrencyPairBankName({ "bankName": bankName }, getCurrencyPairSuccess, getCurrencyPairError);
		}

		function getCurrencyPairSuccess(result) {
			vm.currencyPairList = result

			vm.forexCardLoadList = preparDeliveryModeList(vm.currencyPairList, vm.forexCardLoad);
			vm.currencyNoteList = preparDeliveryModeList(vm.currencyPairList, vm.currencyNotes);
			vm.remittanceList = preparDeliveryModeList(vm.currencyPairList, vm.remittance);
			vm.forexCardIssuanceList = preparDeliveryModeList(vm.currencyPairList, vm.forexCardIssuance);
		}
		function getCurrencyPairError() { }

		function prepardeliveryModeIsEnable(homeBranch) {
			vm.homeBranch.currencyNotesIsEnable = homeBranch.currencyNotes != null && homeBranch.currencyNotes !='';
			vm.homeBranch.forexCardLoadIsEnable = homeBranch.forexCardLoad != null && homeBranch.forexCardLoad !='';
			vm.homeBranch.remittanceIsEnable = homeBranch.remittance != null && homeBranch.remittance !='';
			vm.homeBranch.forexCardIssuanceIsEnable = homeBranch.forexCardIssuance != null && homeBranch.forexCardIssuance !='';
			
		}
	}
})();
